import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, Copy, Search } from "lucide-react";

export const RequestSuccess = ({ ref_, email }) => {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    navigator.clipboard?.writeText(ref_).catch(() => {});
    setCopied(true);
  };
  return (
    <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }} data-testid="request-success">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-emerald-400">Request received</p>
      <h1 className="mt-4 font-display text-4xl font-black uppercase leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl">You're on the bench.</h1>
      <p className="mt-6 max-w-lg text-slate-300">Keep this reference number. You'll need it with your email ({email}) to track your repair.</p>
      <div className="mt-10 flex flex-col items-start gap-4 border border-ember/40 bg-ember/[0.06] p-6 sm:flex-row sm:items-center sm:justify-between md:p-8">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">Your reference</p>
          <p data-testid="success-reference-number" className="mt-1 font-mono text-4xl font-bold text-ember md:text-5xl">{ref_}</p>
        </div>
        <button type="button" onClick={copy} data-testid="copy-reference-btn" className="inline-flex items-center gap-2 border border-white/15 px-4 py-3 text-sm hover:border-ember">
          {copied ? <Check className="h-4 w-4 text-emerald-400" /> : <Copy className="h-4 w-4" />} {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Link to={`/track?ref=${ref_}`} data-testid="success-track-btn" className="inline-flex items-center justify-center gap-2 bg-ember px-6 py-4 font-semibold text-ink hover:bg-amber-400">
          <Search className="h-4 w-4" /> Track this repair
        </Link>
        <Link to="/" data-testid="success-home-btn" className="inline-flex items-center justify-center border border-white/15 px-6 py-4 font-semibold hover:border-ember">Back to home</Link>
      </div>
    </motion.div>
  );
};
